import { Loan, LoanStatus, patchChangeLoanStatus } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { useDocumentsValidationContext } from '@/components/modules/DocumentsValidation/contexts/DocumentsValidationContext';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { useRequest } from '@/hooks/requests/useRequest';

interface UseCancelCardApplication {
  revalidateValues: () => Promise<{ loan: Loan }>;
}

export const useCancelCardApplication = ({ revalidateValues }: UseCancelCardApplication) => {
  const { loan, update } = useDocumentsValidationContext();
  const { request, loading } = useRequest();

  const [cancellationLoading, setCancellationLoading] = useState(false);

  const { opened, setOpened, toggleDialog } = useDialog();

  const onCancel = async () => {
    try {
      setCancellationLoading(true);
      await request(patchChangeLoanStatus, { id: loan.id, status: LoanStatus.STATUS_CANCELLED });
      const { loan: revalidatedLoan } = await revalidateValues();
      update({ loan: revalidatedLoan });
      setOpened(false);
    } catch (error) {
      throw new Error(error as string);
    } finally {
      setCancellationLoading(false);
    }
  };
  return {
    onCancel,
    opened,
    setOpened,
    toggleDialog,
    loading: loading || cancellationLoading,
  };
};
